import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { ChapterHeader } from "./ChapterHeader";

const REVIEWS = [
  { name: "Rohit & Priya Mehta", trip: "Dubai Dazzler · Feb 2026", stars: 5, text: "Visa, hotel, safari — everything was handled before we even asked. The Burj Khalifa sunset slot they booked was perfect. Zero stress, all memories." },
  { name: "Anjali Verma", trip: "Bali Honeymoon · Jan 2026", stars: 5, text: "The private pool villa in Ubud and the candlelight dinner made our honeymoon feel like a film. Kritika ma'am replied on WhatsApp even at midnight!" },
  { name: "Sandeep Kulkarni", trip: "Kashmir Paradise · Apr 2026", stars: 5, text: "Travelled with my parents and two kids. The houseboat night on Dal Lake was the highlight of our year. Drivers were courteous and always on time." },
  { name: "Farah Sheikh", trip: "Thailand Escape · Dec 2025", stars: 5, text: "First international trip and it went flawlessly. Phi Phi speedboat, Safari World, everything as promised — no hidden costs at all." },
  { name: "Vikram Chauhan", trip: "Schengen Visa · Mar 2026", stars: 5, text: "Got my Schengen visa approved in the first attempt after two rejections elsewhere. Their documentation checklist is worth gold." },
  { name: "Neha & Arjun Bansal", trip: "Kerala Backwaters · Nov 2025", stars: 5, text: "The private houseboat with fresh Kerala food was unreal. Gautam Travel planned every transfer so well we never once opened Google Maps." },
];

const Stars = ({ n }) => (
  <div className="flex gap-1">
    {Array.from({ length: n }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-sunset text-sunset" />
    ))}
  </div>
);

export const ReviewsSection = () => (
  <section id="reviews" data-testid="reviews-section" className="relative bg-ink px-6 py-28 md:px-10 md:py-36">
    <div className="mx-auto max-w-7xl">
      <ChapterHeader
        index="04"
        title="Traveller Stories"
        testid="reviews-header"
        heading={
          <>
            Trusted by <span className="italic text-teal">1000+ travellers.</span>
          </>
        }
        blurb="Real journeys, real words. Here's what our travellers say after coming home."
      />
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`review-card-${i + 1}`}
            className="flex flex-col rounded-3xl border border-white/10 bg-surface/80 p-8 backdrop-blur-xl"
          >
            <Quote className="h-6 w-6 text-sunset/60" />
            <blockquote className="mt-4 flex-1 text-sm font-light leading-relaxed text-white/70">
              "{r.text}"
            </blockquote>
            <figcaption className="mt-6 border-t border-white/10 pt-5">
              <Stars n={r.stars} />
              <p className="mt-3 font-display text-lg">{r.name}</p>
              <p className="text-xs uppercase tracking-[0.2em] text-white/40">{r.trip}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
